import { FormGroupSchema, ControlType } from '@slickss/supplystack-components';
import {Settings } from '@ct-client';
import { FormFieldOptions } from '@ct-client/src/models/interfaces/_settings.model';

export const goodsFormSchemaFromSettings = (settings: Settings): FormGroupSchema => ({
    type: {
        required: true,
        type: ControlType.Final
    },
    filterType: {
        required: false,
        type: ControlType.Final
    },
    filterCost: {
        required: false,
        type: ControlType.Final
    },
    costType: {
        required: false,
        type: ControlType.Final
    },
    quantity: {
        required: true,
        type: ControlType.Final
    },
    stackability: {
        required: settings.bRequirePartStackabilityOverrides,
        type: ControlType.Final
    },
    length: {
        required: true,
        type: ControlType.Final
    },
    width: {
        required: true,
        type: ControlType.Final
    },
    height: {
        required: true,
        type: ControlType.Final
    },
    grossWeight: {
        required: true,
        type: ControlType.Final
    },
    netWeight: {
        required: settings.sRequireNetWeight === FormFieldOptions.REQ,
        type: ControlType.Final
    },
    goodsValue: {
        required: settings.sRequireGoodsValue === FormFieldOptions.REQ,
        type: ControlType.Final
    },
    description: {
        required: true,
        type: ControlType.Final
    },
    price: {
        required: false,
        type: ControlType.Final
    },
    dangerous: {
        required: true,
        defaultValue: false,
        type: ControlType.Final
    },
    tempControlled: {
        required: true,
        defaultValue: false,
        type: ControlType.Final
    },
    files: {
        required: false,
        defaultValue: [],
        type: ControlType.Final
    },
    handlingGuidelines: {
        required: false,
        defaultValue: false,
        type: ControlType.Final
    },
    answers: {
        required: false,
        defaultValue: false,
        type: ControlType.Final
    }
});
